import { MenuItem } from 'ts/types'
import {
  BalanceEnquiryLayoutPage,
  ButtonStylePage,
  ClassPage,
  DenominationPage,
  DepartmentPage,
  LayoutPage,
  PaymentTypePage,
  PriceLevelPage,
  ProductPage,
  ProductSubCategoryPage,
  ProductCategoryPage,
  ReceiptPage,
  ReceiptLayoutPage,
  SalesReportPage,
  SubClassPage,
  TaxPage,
  UserPage,
  UserTypePage
} from 'pages/Main'
import {
  BoxIcon,
  ButtonIcon,
  CreditCardIcon,
  DepartmentIcon,
  DollarIcon,
  GroupFoldersIcon,
  GroupIcon,
  LayoutIcon,
  MoneyIcon,
  ProductCategoryIcon,
  ProductIcon,
  SaleIcon,
  ShieldCheckIcon,
  SignOutIcon,
  SubCategoryIcon
} from 'components/svg'
import SignOutPage from 'pages/Auth/SignOutPage'

const menuItems: MenuItem[] = [
  {
    routeName: '/button-style',
    title: 'Button Style',
    icon: <ButtonIcon />,
    component: ButtonStylePage
  },
  {
    routeName: '/class',
    title: 'Class',
    icon: <GroupFoldersIcon />,
    component: ClassPage
  },
  {
    routeName: '/denomination',
    title: 'Denomination',
    icon: <MoneyIcon />,
    component: DenominationPage
  },
  {
    routeName: '/layout',
    title: 'Layout',
    icon: <LayoutIcon />,
    component: LayoutPage
  },
  {
    routeName: '/payment-type',
    title: 'Payment Type',
    icon: <CreditCardIcon />,
    component: PaymentTypePage
  },
  {
    routeName: '/price-level',
    title: 'Price Level',
    icon: <DollarIcon />,
    component: PriceLevelPage
  },
  {
    routeName: '/department',
    title: 'Department',
    icon: <DepartmentIcon />,
    component: DepartmentPage
  },
  {
    routeName: '/product-category',
    title: 'Category',
    icon: <ProductCategoryIcon />,
    component: ProductCategoryPage
  },
  {
    routeName: '/product-sub-category',
    title: 'Sub Category',
    icon: <SubCategoryIcon />,
    component: ProductSubCategoryPage
  },
  {
    routeName: '/product',
    title: 'Product',
    icon: <ProductIcon />,
    component: ProductPage
  },
  {
    routeName: '/sub-class',
    title: 'Sub Class',
    icon: <BoxIcon />,
    component: SubClassPage
  },
  {
    routeName: '/tax',
    title: 'Tax',
    icon: <SaleIcon />,
    component: TaxPage
  },
  {
    routeName: '/receipt',
    title: 'Receipt',
    icon: <SaleIcon />,
    component: ReceiptPage
  },
  {
    routeName: '/balance-enquiry-layout',
    title: 'Balance Enquiry Layout',
    icon: <SaleIcon />,
    component: BalanceEnquiryLayoutPage
  },
  {
    routeName: '/receipt-layout',
    title: 'Receipt Layout',
    icon: <SaleIcon />,
    component: ReceiptLayoutPage
  },
  // {
  //   routeName: '/sales-report',
  //   title: 'Sales Report',
  //   icon: <SaleIcon />,
  //   component: SalesReportPage
  // },
  {
    routeName: '/user',
    title: 'Users',
    icon: <GroupIcon />,
    component: UserPage
  },
  {
    routeName: '/user-type',
    title: 'User Type',
    icon: <ShieldCheckIcon />,
    component: UserTypePage
  },
  {
    routeName: '/sign-out',
    title: 'Sign Out',
    icon: <SignOutIcon />,
    component: SignOutPage
  }
]
export const ProductItems: MenuItem[] = [
  {
    routeName: '/product',
    title: 'Product',
    component: ProductPage
  },
  // {
  //   routeName: '/product-category',
  //   title: 'Category',
  //   component: ProductCategoryPage
  // },
  // {
  //   routeName: '/product-sub-category',
  //   title: 'Sub Category',
  //   component: ProductSubCategoryPage
  // },
  // {
  //   routeName: '/department',
  //   title: 'Department',
  //   component: DepartmentPage
  // },
  {
    routeName: '/class',
    title: 'Class',
    component: ClassPage
  },
  {
    routeName: '/sub-class',
    title: 'Sub Class',
    component: SubClassPage
  },

]
export const LayoutItems: MenuItem[] = [
  {
    routeName: '/layout',
    title: 'Layout',
    component: LayoutPage
  },
  {
    routeName: '/button-style',
    title: 'Button Style',
    component: ButtonStylePage
  }
]
export const ClassItems: MenuItem[] = [
  {
    routeName: '/class',
    title: 'Class',
    component: ClassPage
  },
  {
    routeName: '/sub-class',
    title: 'Sub Class',
    component: SubClassPage
  }
]
export const PriceItems: MenuItem[] = [
  {
    routeName: '/price-level',
    title: 'Price Level',
    component: PriceLevelPage
  },
  {
    routeName: '/payment-type',
    title: 'Payment Type',
    component: PaymentTypePage
  },
  {
    routeName: '/tax',
    title: 'Tax',
    component: TaxPage
  },
  {
    routeName: '/denomination',
    title: 'Denomination',
    component: DenominationPage
  },
]
export const UserItems: MenuItem[] = [
  {
    routeName: '/user',
    title: 'Users',
    component: UserPage
  },
  {
    routeName: '/user-type',
    title: 'User Type',
    component: UserTypePage
  },
  {
    routeName: '/receipt',
    title: 'Receipt',
    component: ReceiptPage
  },
  {
    routeName: '/receipt-layout',
    title: 'Receipt Layout',
    component: ReceiptLayoutPage
  },
  {
    routeName: '/balance-enquiry-layout',
    title: 'Balance Enquiry Layout',
    component: BalanceEnquiryLayoutPage
  },
  // {
  //   routeName: '/sales-report',
  //   title: 'Sales Report',
  //   component: SalesReportPage
  // }
]
export const BottomItems: MenuItem[] = [
  {
    routeName: '/sign-out',
    title: 'Sign Out',
    icon: <SignOutIcon />,
    component: SignOutPage
  }
]

export default menuItems
